<template>
  <q-icon :size="size" :class="className" :data-icon="icon" :color="color">
    <svg v-if="useSvg">
      <use v-bind="{ 'xlink:href': 'svg-icons.svg#' + icon }" />
    </svg>
    <component :is="myComponent" v-else />
  </q-icon>
</template>

<script>
import { markRaw } from 'vue'
export default {
  name: 'svg-icon',
  props: {
    icon: { type: String, default: 'arrow-down' },
    size: { type: String, default: '' },
    className: { type: [String, Array], default: '' },
    color: { type: String, default: '' },
    useSvg: { type: Boolean, default: true },
  },
  data() {
    return {
      myComponent: null, // Store the dynamically loaded component
    }
  },
  methods: {
    async loadComponent() {
      if (!this.useSvg) {
        try {
          const module = await import(`./svg-icons/${this.icon}.vue`)
          this.myComponent = markRaw(module.default)
        } catch (error) {
          console.error('Failed to load SVG component:', error)
        }
      }
    },
  },
  watch: {
    icon: 'loadComponent',
  },
  created() {
    this.loadComponent()
  },
}
</script>
